"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Applicants = Applicants;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const elements_1 = require("@src/components/elements");
const Api = __importStar(require("@src/api"));
const get_cdn_image_url_1 = require("@shared/get-cdn-image-url");
const date_fns_1 = require("date-fns");
const debounce_1 = __importDefault(require("lodash/debounce"));
const localized_path_1 = require("@src/shared/localized-path");
const react_intl_1 = require("react-intl");
const react_router_1 = require("react-router");
const isApplicantAccountAnonymized_1 = require("@src/helpers/isApplicantAccountAnonymized");
const Applicants_style_1 = require("./Applicants.style");
const AvatarWithName = ({ account }) => {
    const { uuid: applicantUuid, profilePictureUrl: imageSrc, firstName, lastName } = account;
    const isAnonymized = (0, isApplicantAccountAnonymized_1.isApplicantAccountAnonymized)(account);
    const location = (0, react_router_1.useLocation)();
    const locale = (0, localized_path_1.getLanguageFromPathname)(location.pathname);
    const localizedPath = (0, localized_path_1.getLocalizedPath)(`/admin/uchadzaci/pouzivatel/${applicantUuid}`, locale);
    const nameContent = isAnonymized ? ((0, jsx_runtime_1.jsx)("span", { children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.company_applicant.user_deleted" }) })) : ((0, jsx_runtime_1.jsxs)("span", { children: [firstName, " ", lastName] }));
    const avatar = ((0, jsx_runtime_1.jsx)(elements_1.Avatar, { account: account, className: "m-r-m", size: 30, src: isAnonymized || !imageSrc ? null : (0, get_cdn_image_url_1.getCdnImageUrl)({ file: `web/account/${imageSrc}` }) }));
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row align-center", style: isAnonymized ? { opacity: 0.5 } : undefined, children: [applicantUuid && !isAnonymized && ((0, jsx_runtime_1.jsxs)(Applicants_style_1.BlackTextLink, { href: localizedPath, target: "_blank", rel: "noopener, noreferrer", children: [avatar, nameContent] })), (isAnonymized || !applicantUuid) && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [avatar, nameContent] }))] }));
};
const DetailButton = ({ applicantUuid, isAnonymized }) => {
    const location = (0, react_router_1.useLocation)();
    const locale = (0, localized_path_1.getLanguageFromPathname)(location.pathname);
    const localizedPath = (0, localized_path_1.getLocalizedPath)(`/admin/uchadzaci/pouzivatel/${applicantUuid}`, locale);
    const disabled = !applicantUuid || isAnonymized;
    if (disabled) {
        return ((0, jsx_runtime_1.jsx)(elements_1.Button, { size: "middle", type: "default", disabled: true, children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.applicants.table.profile" }) }));
    }
    return ((0, jsx_runtime_1.jsx)(Applicants_style_1.BlackTextLink, { href: localizedPath, target: "_blank", rel: "noopener, noreferrer", children: (0, jsx_runtime_1.jsx)(elements_1.Button, { size: "middle", type: "default", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.applicants.table.profile" }) }) }));
};
const LastActivity = ({ applicant }) => {
    var _a;
    const applicantApplications = applicant.offerApplication;
    let newestApplication;
    if (applicantApplications instanceof Array) {
        // eslint-disable-next-line prefer-destructuring
        newestApplication = applicantApplications.sort((a, b) => new Date(b.created_at).valueOf() - new Date(a.created_at).valueOf())[0];
    }
    else {
        newestApplication = applicantApplications;
    }
    const date = (0, date_fns_1.format)((0, date_fns_1.parseISO)((_a = newestApplication.created_at) === null || _a === void 0 ? void 0 : _a.toString()), 'dd.MM.yyyy');
    return ((0, jsx_runtime_1.jsxs)("div", { className: "flex-row", children: [(0, jsx_runtime_1.jsx)(Applicants_style_1.OfferTitle, { className: "m-r-m", children: newestApplication.offer_title }), (0, jsx_runtime_1.jsx)(Applicants_style_1.GrayText, { children: date })] }));
};
const rowsOnPage = 20;
function Applicants() {
    const intl = (0, react_intl_1.useIntl)();
    const [filterValues, setFilterValues] = react_1.default.useState({
        name: '',
        school: '',
        position: '',
    });
    const [pageStats, setPageStats] = react_1.default.useState({
        page: 1,
        pageCount: 0,
        total: 0,
    });
    const [tableRows, setTableRows] = react_1.default.useState([]);
    async function fetchCompanyApplicants() {
        const companyApplicantsWithPageSettings = await Api.Company.getCompanyApplicants(filterValues, pageStats.page);
        const newPageStats = companyApplicantsWithPageSettings.pagination;
        setPageStats({
            page: newPageStats.page,
            pageCount: newPageStats.pageCount,
            total: newPageStats.rowCount,
        });
        setTableRows(companyApplicantsWithPageSettings.applicants.map((applicant) => ({
            key: applicant.account.id,
            name: (0, jsx_runtime_1.jsx)(AvatarWithName, { account: applicant.account }),
            activity: (0, jsx_runtime_1.jsx)(LastActivity, { applicant: applicant }),
            detail: ((0, jsx_runtime_1.jsx)(DetailButton, { applicantUuid: applicant.account.uuid, isAnonymized: (0, isApplicantAccountAnonymized_1.isApplicantAccountAnonymized)(applicant.account) })),
        })));
    }
    const columns = [
        {
            title: intl.formatMessage({ id: 'admin.applicants.table.name' }),
            dataIndex: 'name',
            key: 'name',
            width: '45%',
        },
        {
            title: intl.formatMessage({
                id: 'admin.applicants.table.last_activity',
            }),
            dataIndex: 'activity',
            key: 'activity',
            width: '45%',
        },
        {
            title: '',
            dataIndex: 'detail',
            key: 'detail',
            width: '10%',
        },
    ];
    async function loadMoreApplicants() {
        const companyApplicantsWithPageSettings = await Api.Company.getCompanyApplicants(filterValues, pageStats.page + 1);
        const newPageStats = companyApplicantsWithPageSettings.pagination;
        setPageStats({
            page: newPageStats.page,
            total: newPageStats.rowCount,
            pageCount: newPageStats.pageCount,
        });
        setTableRows([
            ...tableRows,
            ...companyApplicantsWithPageSettings.applicants.map(applicant => ({
                key: applicant.account.id,
                name: (0, jsx_runtime_1.jsx)(AvatarWithName, { account: applicant.account }),
                activity: (0, jsx_runtime_1.jsx)(LastActivity, { applicant: applicant }),
                detail: ((0, jsx_runtime_1.jsx)(DetailButton, { applicantUuid: applicant.account.uuid, isAnonymized: (0, isApplicantAccountAnonymized_1.isApplicantAccountAnonymized)(applicant.account) })),
            })),
        ]);
    }
    function onInputChange(value, key) {
        setPageStats({
            page: 1,
            total: 0,
            pageCount: 0,
        });
        switch (key) {
            case 'name':
                setFilterValues({ ...filterValues, name: value });
                break;
            case 'school':
                setFilterValues({ ...filterValues, school: value });
                break;
            case 'position':
                setFilterValues({ ...filterValues, position: value });
                break;
            // no default
        }
    }
    const debounceOnInputChange = (0, debounce_1.default)(onInputChange, 200);
    react_1.default.useEffect(() => {
        fetchCompanyApplicants();
    }, [filterValues]);
    return ((0, jsx_runtime_1.jsxs)(elements_1.Panel, { children: [(0, jsx_runtime_1.jsxs)("div", { className: "flex-row justify-space-between m-b-m", children: [(0, jsx_runtime_1.jsx)(Applicants_style_1.StyledInput, { placeholder: intl.formatMessage({
                            id: 'admin.applicants.name.placeholder',
                        }), onChange: e => debounceOnInputChange(e.target.value, 'name') }), (0, jsx_runtime_1.jsx)(Applicants_style_1.StyledInput, { placeholder: intl.formatMessage({
                            id: 'admin.applicants.school.placeholder',
                        }), onChange: e => debounceOnInputChange(e.target.value, 'school') }), (0, jsx_runtime_1.jsx)(Applicants_style_1.StyledInput, { placeholder: intl.formatMessage({
                            id: 'admin.applicants.position.placeholder',
                        }), onChange: e => debounceOnInputChange(e.target.value, 'position') })] }), (0, jsx_runtime_1.jsx)(elements_1.Table, { columns: columns, dataSource: tableRows, pagination: false }), pageStats.total > rowsOnPage && pageStats.page < pageStats.pageCount && ((0, jsx_runtime_1.jsx)(Applicants_style_1.FullWidthCentredDiv, { children: (0, jsx_runtime_1.jsx)(elements_1.Button, { onClick: () => loadMoreApplicants(), size: "middle", className: "m-t-m", children: (0, jsx_runtime_1.jsx)(react_intl_1.FormattedMessage, { id: "admin.applicants.load_more" }) }) }))] }));
}
